// extracted by mini-css-extract-plugin
export default {"btn":"Character_btn__qX3hr","icon":"Character_icon__uGJza","buttons":"Character_buttons__+FIQ6"};